



























import Vue from 'vue';
import Component from 'vue-class-component';
import IdentityButtons from './identity/IdentityButtons.vue';

@Component
export default class LoaderTopPanel extends Vue {

}
